/**
 * Non-essential tracker registry (RQ78378 / RQ78379).
 *
 * Intentionally minimal — Dreamwrite has exactly one non-essential tracker
 * today: its own first-party product-analytics event log (RFC-0974). There are
 * NO third-party trackers left (Mixpanel removed in RQ78378; Sentry removed —
 * see RFC-1172). This is NOT a CSP governor: the console CSP is a static,
 * hand-maintained string across four edge surfaces. This list only drives
 * (a) which collectors the consent gates may enable and (b) which category
 * toggles the preferences UI shows. Adding a vendor = one entry here plus (if
 * its host is new) a manual CSP edit.
 */

import type { ConsentCategory } from './consentTypes'

export interface Tracker {
  /** Stable id. */
  id: string
  /**
   * i18n key (in the `settings` namespace) for the label the granular
   * preferences UI renders. Not raw copy — the modal resolves it via `t()` so
   * the vendor list is translated like every other string in that dialog.
   */
  labelKey: string
  /** Consent bucket this tracker belongs to. */
  category: ConsentCategory
}

export const TRACKERS: readonly Tracker[] = [
  {
    id: 'product_analytics',
    labelKey: 'consentPreferences.trackerProductAnalytics',
    category: 'analytics',
  },
]

/**
 * The non-necessary categories that have ≥1 registered tracker. The preferences
 * UI shows a toggle for each of these (plus the always-on Necessary row), so it
 * auto-grows when a vendor in a new category is added. Today: just `analytics`.
 */
export function categoriesWithTrackers(): Set<ConsentCategory> {
  const set = new Set<ConsentCategory>()
  for (const tracker of TRACKERS) {
    if (tracker.category !== 'strictly_necessary') {
      set.add(tracker.category)
    }
  }
  return set
}
